import { ArrowLeftOutlined } from '@ant-design/icons'
import { Tabs } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { Button, ContentBody, ContentHeader } from '../../../core/components'
import useCustomer from '../../../services/queries/customer/useCustomer'
import {
  AccompanimentsTab,
  AddressTab,
  ContactsTab,
  ContractsTab,
  FinancialTab,
  GeneralTab,
  LastProductsTab,
  OpportunitiesTab,
  PersonalDataTab
} from './tabs'
import { ServiceOrdersTab } from './tabs/ServiceOrder'

const { TabPane } = Tabs

export const DetailCustomerPage = () => {
  const { goBack } = useHistory()
  const { id }: any = useParams()
  const { data: customer, error, isLoading }: any = useCustomer(id)

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <div>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Detalhes do Cliente
      </ContentHeader>
      <ContentBody>
        <Tabs type="line">
          <TabPane tab="Geral" key="1">
            <GeneralTab />
          </TabPane>
          <TabPane tab="Endereços" key="2">
            <AddressTab />
          </TabPane>
          <TabPane tab="Contratos" key="3">
            <ContractsTab />
          </TabPane>
          <TabPane tab="Acompanhamentos" key="4">
            <AccompanimentsTab />
          </TabPane>
          {customer?.data?.legalEntity === 0 ? (
            <TabPane tab="Contatos" key="5">
              <ContactsTab />
            </TabPane>
          ) : (
            <TabPane tab="Dados Pessoais" key="6">
              <PersonalDataTab />
            </TabPane>
          )}
          <TabPane tab="Oportunidades" key="7">
            <OpportunitiesTab />
          </TabPane>
          <TabPane tab="Financeiro" key="8">
            <FinancialTab />
          </TabPane>
          <TabPane tab="Últimas Vendas" key="9">
            <LastProductsTab />
          </TabPane>
          <TabPane tab="O.S." key="10">
            <ServiceOrdersTab />
          </TabPane>
        </Tabs>
      </ContentBody>
    </div>
  )
}
